'use strict';

/**
 * 
 * Subscription add to cart fulfillment. 
 * 
 */

if (document.body.dataset.templateType == 'subscription') {
  document.querySelector('#subscription-to-cart').addEventListener('click', function () {
    var handle = document.querySelector("#subscribe-select").value;
    init(handle);
  });
}

var init = function init(handle) {
  var productId = void 0;
  fetch('/products/' + handle + '.js', {
    method: 'GET',
    credentials: 'same-origin'
  }).then(function (response) {
    return response.json();
  }).then(function (json) {
    productId = json.variants[0].id;
    return productId;
  }).then(function (productId) {
    var product = {
      quantity: 1,
      id: productId
    };
    addSubscribtionToCart(product);
  });
};

var addSubscribtionToCart = function addSubscribtionToCart(product) {
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(product)
  }).then(function (response) {
    getCart();
    return response.json();
  }).catch(function (err) {
    alert('Uh oh! Something went wrong. Please try again.');
    console.log(err);
  });
};
var getCart = function getCart() {
  return fetch('/cart.js', {
    method: 'GET',
    credentials: 'same-origin'
  }).then(function (response) {
    return response.json();
  }).then(function (json) {
    var cart = document.querySelector('#cart-indicator span.item-count');
    cart.innerText = '(' + json.item_count + ')';
  });
};